import * as React from 'react';
import { green, pink } from '@mui/material/colors';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import FolderIcon from '@mui/icons-material/Folder';
import PageviewIcon from '@mui/icons-material/Pageview';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Link as RouterLink } from 'react-router-dom';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';

export default function MobileMenu() {
  const appMode = useSelector((state) => state.mode.mode);

  return (
     
    <Grid container px={2} mt={1}  mb={4} rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
      <Grid item xs={3}>
        <Box component={RouterLink}  to='/start-trading' sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', borderRadius: '50%',  textDecoration: 'none', color: 'inherit' }}>
          <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378459/candle_l9uey7-white_bkdamr.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378459/candle_l9uey7_b6819z.png'} sx={{ padding: '5px', width: 40, height: 40}}>
            {/* <ArrowOutwardIcon /> */}
          </Avatar>  
          <Typography sx={{textAlign: 'center', fontSize: '12px'}}>Trade</Typography>   
        </Box>
      </Grid>

      <Grid item xs={3}>
        <Box component={RouterLink}  to='/package/Trading Plans' sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', borderRadius: '50%',  textDecoration: 'none', color: 'inherit' }}>
          <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378458/profits_atawbu-white_secer5.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378458/profits_atawbu_wfobgd.png'} sx={{ padding: '5px', width: 40, height: 40}}>
            {/* <ArrowOutwardIcon /> */}
          </Avatar>  
          <Typography sx={{textAlign: 'center', fontSize: '12px'}}>Invest</Typography>   
        </Box>
      </Grid>

      <Grid item xs={3}>
        <Box component={RouterLink}  to='/account-wallet' sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', borderRadius: '50%',  textDecoration: 'none', color: 'inherit' }}>
          <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378457/wallet_b7ymoh-white_gogbhy.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378457/wallet_b7ymoh_j1jnj4.png'} sx={{ padding: '5px', width: 40, height: 40}}>
            {/* <ArrowOutwardIcon /> */}
          </Avatar>  
          <Typography sx={{textAlign: 'center', fontSize: '12px'}}>Deposits</Typography>   
        </Box>
      </Grid>

      <Grid item xs={3}>
        <Box component={RouterLink}  to='/send-coin' sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', borderRadius: '50%',  textDecoration: 'none', color: 'inherit' }}>
          <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378455/deposit_bvwyrg-white_bxe0j2.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378455/deposit_bvwyrg_yx8unu.png'} sx={{ padding: '5px', width: 40, height: 40}}>
            {/* <ArrowOutwardIcon /> */}
          </Avatar>  
          <Typography sx={{textAlign: 'center', fontSize: '12px'}}>Withdraw</Typography>   
        </Box>
      </Grid>

      <Grid item xs={3}>
        <Box component={RouterLink}  to='/joint-accounts' sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', borderRadius: '50%',  textDecoration: 'none', color: 'inherit' }}>
          <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378456/swap_vw5hqj-white_a1fumo.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378455/swap_vw5hqj_lnjjfj.png'} sx={{ padding: '5px', width: 40, height: 40}}>
            {/* <ArrowOutwardIcon /> */}
          </Avatar>  
          <Typography sx={{textAlign: 'center', fontSize: '12px'}}>Partner</Typography>   
        </Box>
      </Grid>

      <Grid item xs={3}>
        <Box component={RouterLink}  to='/web3' sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', borderRadius: '50%',  textDecoration: 'none', color: 'inherit' }}>
          <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378455/web3_ztvzkf-white_jaiwxy.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378458/web3_ztvzkf_vres91.png'} sx={{ padding: '5px', width: 40, height: 40}}>
            {/* <ArrowOutwardIcon /> */}
          </Avatar>  
          <Typography sx={{textAlign: 'center', fontSize: '12px'}}>WEB3</Typography>   
        </Box>
      </Grid>

      <Grid item xs={3}>
        <Box component={RouterLink}  to='/copy-plans' sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', borderRadius: '50%',  textDecoration: 'none', color: 'inherit' }}>
          <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378458/analytics_tjm1c0-white_qnmqka.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378458/analytics_tjm1c0_ybaoen.png'} sx={{ padding: '5px', width: 40, height: 40}}>
            {/* <ArrowOutwardIcon /> */}
          </Avatar>  
          <Typography sx={{textAlign: 'center', fontSize: '12px'}}>Joint Invest</Typography>   
        </Box>
      </Grid>

      <Grid item xs={3}>
        <Box component={RouterLink}  to='/assets' sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', borderRadius: '50%',  textDecoration: 'none', color: 'inherit' }}>
          <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378457/wallet_1_vmr3li-white_i8qljf.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378457/wallet_1_vmr3li_ab9ero.png'} sx={{ padding: '5px', width: 40, height: 40}}>
            {/* <ArrowOutwardIcon /> */}
          </Avatar>  
          <Typography sx={{textAlign: 'center', fontSize: '12px'}}>Assets</Typography>   
        </Box>
      </Grid>
    </Grid>
  );
}